import { API_URLS } from '../helpers/api/API_URLS';
import { basicGET, basicJSONPOST, basicFILEPOST, basicJSONDELETE } from '../helpers/api/fetchParams';

// let token = localStorage.getItem("token");

// GET FUNCTIONS ----------------------------------------------------------------------
export async function getAllClients() {
    var token = localStorage.getItem("token");
	const response = await fetch(API_URLS.listClients, basicGET(token));
    if (!response.ok) {
        const message = "An error has occured: "+response.status;
        throw new Error(message);
    }
    const data = await response.json();
    return data;
}

export async function getClient(clientCode) {
    var token = localStorage.getItem("token");
	const response = await fetch(API_URLS.API + clientCode, basicGET(token))
    if (!response.ok) {
        const message = "An error has occured: "+response.status;
        throw new Error(message);
    }
    const data = await response.json();
    return data.result;
}

export async function getTransactions(clientCode) {
    var token = localStorage.getItem("token");
	const response = await fetch(API_URLS.API+"transactions/"+clientCode, basicGET(token))
    if (!response.ok) {
		// console.log(response)
        const message = "An error has occured: "+response.status;
        throw new Error(message);
    }
    const data = await response.json();
    return data.result;
}

export async function getCredentials(clientCode) {
	var token = localStorage.getItem("token");
	const response = await fetch(API_URLS.API + clientCode + "/credential", basicGET(token));
	if (!response.ok) {
		const message = 'An error has occured: '+response.status;
		throw new Error(message);
	}
	const data = await response.json();
	return data;
}















// POST FUNCTIONS ----------------------------------------------------------------------
export async function addClient(body) {
    console.log("addClient running");
    console.log(body);
    var token = localStorage.getItem("token");
	const response = await fetch(API_URLS.addClientUrl, basicJSONPOST(token, body));
    if (!response.ok) {
        const message = "An error has occured: "+response.status;
        throw new Error(message);
    }
    const data = await response.json();
    return data;
}

export async function addContact(body) {
    // console.log("addContact running");
    var token = localStorage.getItem("token");
	const response = await fetch(API_URLS.postContact, basicJSONPOST(token, body));
    if (!response.ok) {
        const message = "An error has occured: "+response.status;
        throw new Error(message);
    }
    const data = await response.json();
    return data;
}

export async function addLocation(body) {
    // console.log("addLocation running");
    var token = localStorage.getItem("token");
	const response = await fetch(API_URLS.postLocation, basicJSONPOST(token, body));
    if (!response.ok) {
        const message = "An error has occured: "+response.status;
        throw new Error(message);
    }
    const data = await response.json();
    return data;
}

export async function addImage(clientCode, body) {
	var token = localStorage.getItem("token");
	const response = await fetch(API_URLS.API+clientCode+"/logo", basicFILEPOST(token, body, "POST"));
    if (!response.ok) {
        const message = "An error has occured: "+response.status;
        throw new Error(message);
    }
    const data = await response.json();
    return data;
}

export async function saveCredential(body) {
	var token = localStorage.getItem("token");
	const response = await fetch(API_URLS.credCreate, basicJSONPOST(token, body));
	if (!response.ok) {
		const message = 'An error has occured: '+response.status;
		throw new Error(message);
	}
	const data = await response.json();
	return data;
}

export async function saveSiteSettings(clientCode, body) {
    var token = localStorage.getItem("token");
    const response = await fetch(API_URLS.site+clientCode, basicJSONPOST(token, body));
    if (!response.ok) {
        const message = 'An error has occured: '+response.status;
        throw new Error(message);
    }
    const data = await response.json();
    return data;
}


















// DELETE FUNCTIONS ----------------------------------------------------------------------
export async function deleteCredential(id) {
	var token = localStorage.getItem("token");
	const response = await fetch(API_URLS.credCreate+"/"+id, basicJSONDELETE(token, {}));
	if (!response.ok) {
		const message = 'An error has occured: '+response.status;
		throw new Error(message);
	}
	const data = await response.json();
	return data;
}

export async function deleteContact(id) {
    var token = localStorage.getItem("token");
    const response = await fetch(API_URLS.postContact+"/"+id, basicJSONDELETE(token));
    if (!response.ok) {
        const message = 'An error has occured: '+response.status;
        throw new Error(message);
    }
    const data = await response.json();
    return data;
}


// WEBPACK FOOTER //
// ./src/data/serviceClients.js